import { CATEGORY, CATEGORY_DESCRIPTION, ERROR_MESSAGES, LEVELNAME, LEVEL_LIST, MAX_LIMIT, QUANTITY_LIST_ECOLIER, QUANTITY_LIST_OTHER, QUIZ_TYPE, ROLE, TIMER } from "../utils/constants";
import { CapitalizeTitle, CreateIconStyled, IconStar, IconStarOutline, InfoDeleteQuiz, LevelStyled, PaperStyled, QuantityStyled, SpinnerBtn, SubTitle, TimerStyled, Title, WrapperCreator, WrapperOptionStyled } from "./CategoryCreateQuiz.styled";
import { Button} from "@mui/material";
import { useEffect, useState } from "react";
import { useCreateQuiz } from "../hooks/useCreateQuiz";
import { createQuizFn, createQuizForClassroomFn } from "../utils/createQuizFn";
import { toast } from 'react-hot-toast';
import { CreateQuizPopup } from "./modals/CreateQuizPopup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { useAddQuizToStudent, useGetCurrentStudent } from "../hooks/useStudent";
import { useAuth } from "../context/authContext";
import { ShareQuizPopup } from "../components/modals/ShareQuizPopup";
import { useAddQuizToClassroom } from "../hooks/useQuiz";
import { useGetAllClassroom } from "../hooks/useClassroom";



export const CreateQuizRegister = () => {
    const { category } = useParams();
    const { role} = useAuth();    
    const theme = useTheme();
    // const navigate = useNavigate();
    const location = useLocation();
    const { idClassroom, quizType } = location.state || {};
    
    const { createQuiz, isCreating } = useCreateQuiz();
    const { student } = useGetCurrentStudent();
    const { addQuiz, isAdditingQuiz } = useAddQuizToStudent();
    const { addQuiz: AddQuizToClassroom, isAdditing } = useAddQuizToClassroom();
    const { response, isLoading } = useGetAllClassroom();

    const [allQuestions, setAllQuestions] = useState([]);
    const [quantity, setQuantity] = useState(null);
    const [level, setLevel] = useState(null);    
    const [isActiveTimer, setIsActiveTimer] = useState(null);
    const [idQuiz, setIdQuiz] = useState(null);
    const [idFastQuiz, setIdFastQuiz] = useState(null);
    const [isOpenPopup, setIsOpenPopup] = useState(false); 
    const [isOpenSharePopup, setIsOpenSharePopup] = useState(false);
    const [classroomList, setClassroomList] = useState([]);

    useEffect(() => { 
        if (response?.classroomList) {           
            setClassroomList(response?.classroomList);
        }
    }, [response])

    useEffect(() => {             
        const getQuizzes = async () => {
            try {
               const quizzes = await import(`../utils/${category}Tasks.json`);
                if (quizzes?.default) {
                    setAllQuestions(quizzes.default);
                }
            } catch (error) {
                toast.error(ERROR_MESSAGES[404], { duration: 6000 });
            } 
        }        
        if (category) {
            getQuizzes();           
        }  
    }, [category]);
    
   
    const handleCleanInfoCreatedQuiz = () => {
        setQuantity(null);
        setLevel(null);
        setIsActiveTimer(null);
        setIdQuiz(null);
    }

    const handleClosePopup = () => {
        setIsOpenPopup(false);
        handleCleanInfoCreatedQuiz();
    }

    const helperCreateQuiz = async (questions, quizType) => { 
        
        if (questions.length === 0) {
            toast.error(ERROR_MESSAGES[404], { duration: 6000 });
            return;
        }; 

        // if (student?.quizList.length >= MAX_LIMIT.QUIZ && quizType===QUIZ_TYPE.PERSONAL) {
        //     toast(ERROR_MESSAGES["ERR_REACHED_MAX_LIMIT_QUIZ"], {
        //             icon: '⚠️',
        //             duration: 5000,
        //     });
        //     navigate('/dashboard?tab=quiz');
        //     return;
        // }
        
        const quiz = {
            category,
            level,
            tasks: questions,
            timer: isActiveTimer? TIMER[`QUANTITY_${quantity}`]: 0,
        };
        const response = await createQuiz(quiz);
        if (response) {
            setIdQuiz(response);
            setIsOpenPopup(true);            
            return response;
        }
    }

    
    const handleCreateQuiz = async () => {
         if (!quantity || !level || isActiveTimer === null) {
            toast(`Scegli: ${!quantity? '~la quantità dei quesiti;':''} ${!level? '~il livello di difficoltà;':''} ${isActiveTimer===null ? '~se azionare il timer oppure no;':''}`, {
                icon: '⚠️',
                duration: 6000,
            });
            return;
        }       
        
        if (role === ROLE.TEACHER && !idClassroom) {
            setIsOpenSharePopup(true); 
            return;
        }
        if (role === ROLE.TEACHER && idClassroom) {
            const checkedClassroom = classroomList.find(({ _id }) => _id === idClassroom);
            if (!checkedClassroom) return;
            const createdQuestions = createQuizForClassroomFn({ allQuestions, quantity, level, classroomList: [checkedClassroom] });   
            const id = await helperCreateQuiz(createdQuestions, QUIZ_TYPE.FASTQUIZ);
            if (!id) return;
            const idFastQuiz = await AddQuizToClassroom({ idClassroom, idQuiz: id, quizType: QUIZ_TYPE.FASTQUIZ });
            if (!idFastQuiz) return;
            setIdFastQuiz(idFastQuiz);
        }
        if (role === ROLE.STUDENT) {
            const createdQuestions = createQuizFn({ allQuestions, quantity, level, resolvedQuizzes: student?.resolvedQuizzes });
            const id = await helperCreateQuiz(createdQuestions, QUIZ_TYPE.PERSONAL); 
            if (id) {
             await addQuiz({ idQuiz: id });   
            }            
        }
    }

    const handleCreatePrivateQuiz = async () => {
        setIsOpenSharePopup(false);
        const createdQuestions = createQuizFn({ allQuestions, quantity, level, resolvedQuizzes: student?.resolvedQuizzes });
        const id = await helperCreateQuiz(createdQuestions, QUIZ_TYPE.PERSONAL); 
        if (id) {
             await addQuiz({ idQuiz: id });   
            }
    }

    const handleCreateShareQuiz = async checkedClassroomList => {
        setIsOpenSharePopup(false);
        const createdQuestions = createQuizForClassroomFn({ allQuestions, quantity, level, classroomList: checkedClassroomList });
        return helperCreateQuiz(createdQuestions, QUIZ_TYPE.CLASSROOM);
    }


    return (
        <>         
            {isOpenSharePopup && role === ROLE.TEACHER && !idClassroom &&
                <ShareQuizPopup
                    isOpen={isOpenSharePopup}
                    onClose={()=>setIsOpenSharePopup(false)}
                    onCreatePrivateQuiz={handleCreatePrivateQuiz}
                    onCreateShareQuiz={handleCreateShareQuiz}
                    onSetIdFastQuiz={setIdFastQuiz}
                />}
            
            {isOpenPopup && 
                <CreateQuizPopup
                    isOpenPopup={isOpenPopup}
                    onClosePopup={handleClosePopup}       
                    infoQuiz={{
                    category,
                    quantity,
                    level,
                    timer: isActiveTimer? TIMER[`QUANTITY_${quantity}`]: 0,
                    idQuiz,
                    idFastQuiz,
                }}                             
                />}
            
            
                <WrapperCreator>
                    <Title>
                        <span>Crea quiz</span>
                        <p><CapitalizeTitle>{category}: </CapitalizeTitle><span>{CATEGORY_DESCRIPTION[category]}</span></p>
                    </Title>
                    <InfoDeleteQuiz>I quiz personalizzati saranno disponibili per <b>15 giorni</b></InfoDeleteQuiz>
                    <PaperStyled elevation={3}>
                        <SubTitle>Quanti quesiti vuoi avere nel Quiz?</SubTitle>
                        <WrapperOptionStyled>
                            {category === CATEGORY.ECOLIER && QUANTITY_LIST_ECOLIER.map(quantityObj => {
                                return (
                                    <QuantityStyled
                                    key={quantityObj.quantity}
                                    category={category}
                                    onClick={() => setQuantity(quantityObj.quantity)}
                                    style={{
                                        backgroundColor: quantity === quantityObj.quantity && `${theme.palette[category].main}`,
                                        color: quantity === quantityObj.quantity && `${theme.palette.text.light}`
                                    }}>                            
                                        {quantityObj.quantity}
                                    </QuantityStyled>);
                            })}
                            {category !== CATEGORY.ECOLIER && QUANTITY_LIST_OTHER.map(quantityObj => {
                                return (
                                    <QuantityStyled
                                        key={quantityObj.quantity}
                                        category={category}
                                        onClick={() => setQuantity(quantityObj.quantity)}
                                        style={{
                                            backgroundColor: quantity === quantityObj.quantity && `${theme.palette[category].main}`,
                                            color: quantity === quantityObj.quantity && `${theme.palette.text.light}`
                                        }}>
                                        {quantityObj.quantity}
                                    </QuantityStyled>);
                            })}
                        </WrapperOptionStyled>
                    </PaperStyled>   
            

            <PaperStyled elevation={3}>
                <SubTitle>Personalizza la difficoltà</SubTitle> 
                <WrapperOptionStyled>
                    {LEVEL_LIST.map(levelObj => {
                        return (
                            <LevelStyled
                                key={levelObj.level}
                                category={category}
                                onClick={() => setLevel(levelObj.level)}
                                style={{
                                    backgroundColor: level === levelObj.level && `${theme.palette[category].main}`,
                                    color: level === levelObj.level && `${theme.palette.text.light}`
                                }}> 
                                {(levelObj.level === LEVELNAME.ELEMENTARY) && <><IconStar /><IconStarOutline/><IconStarOutline/></>}
                                {(levelObj.level===LEVELNAME.MEDIUM) && <><IconStar/><IconStar/><IconStarOutline/></>}
                                {(levelObj.level===LEVELNAME.HARD) && <><IconStar/><IconStar/><IconStar /></>}
                                {(levelObj.level===LEVELNAME.STANDARD) && 'mix'}
                                
                            </LevelStyled>)
                    })}
                </WrapperOptionStyled>           
            </PaperStyled>


            <PaperStyled elevation={3}>
                <SubTitle>Timer</SubTitle> 
                <WrapperOptionStyled>                    
                    <TimerStyled
                        category={category}
                        onClick={() => setIsActiveTimer(true)} 
                        style={{
                                    backgroundColor: isActiveTimer && `${theme.palette[category].main}`,
                                    color: isActiveTimer && `${theme.palette.text.light}`
                                }}
                    >
                        {(!quantity || !isActiveTimer) && 'on'}
                        {(quantity && isActiveTimer) && `${TIMER[`QUANTITY_${quantity}`]}'`}
                    </TimerStyled>
                    <TimerStyled
                        category={category}
                        onClick={() => setIsActiveTimer(false)}
                        style={{
                                    backgroundColor: isActiveTimer===false && `${theme.palette[category].main}`,
                                    color: isActiveTimer===false && `${theme.palette.text.light}`
                                }}
                    >
                        off
                    </TimerStyled>                 
                </WrapperOptionStyled>           
            </PaperStyled>


            <Button variant="contained" color={category} onClick={handleCreateQuiz} disabled={isCreating}>
                crea quiz
                        {isCreating && <SpinnerBtn size={16} />}
                        {!isCreating && <CreateIconStyled/>}
                    </Button> 


        </WrapperCreator>
        </>
        
        
    )
};

